import SelectBox from "components/Common/SelectBox"
import { FabricOptions } from "components/CustomSelect"
import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
} from "reactstrap"

export default function Specifications(props) {
  const { config } = props
  console.log(props)
  const [jacketSpecs, setJacketSpecs] = useState([])

  const { jacketSpecifications, setJacketSpecificatons, handleJacketInput } =
    config

  useEffect(() => {
    if (!jacketSpecs?.length) return loadSpecs()
  }, [props])

  const loadSpecs = () => {
    if (config && config.orderSheets) {
      const specs = config.orderSheets?.jacket?.specifications
        .filter(item => item.answer)
        .map(item => ({
          value: item.labels[0].sequence,
          label: item.labels[0].label,
        }))

      setJacketSpecs(specs)
    }
  }
  const onTextInputChange = (e, obj, idx) => {
    const answer = {
      sequence: parseInt(e.target.dataset.sequence),
      answer: e.target.value,
    }
    const spec = {
      formId: obj.formId,
      sequence: obj.sequence,
      answers: [answer],
    }
    handleJacketInput(spec, "specifications", idx)
  }

  const onCheckboxChecked = (e, obj, idx) => {
    const answers = []
    const grandParent = e.target.parentNode.parentNode
    const checkBoxes = grandParent.querySelectorAll(`[name="${e.target.name}"]`)
    checkBoxes.forEach(checkBox => {
      if (checkBox.checked) {
        const { answer } = checkBox.dataset
        answers.push({
          sequence: parseInt(checkBox.value),
          answer: answer,
        })
      }
    })

    const spec = {
      formId: obj.formId,
      sequence: obj.sequence,
      answers: answers,
    }
    handleJacketInput(spec, "specifications", idx)
  }

  const onRadioSelect = (e, obj, idx, label) => {
    const answer = {
      sequence: parseInt(e.target.value),
      answer: label,
    }

    const spec = {
      formId: obj.formId,
      sequence: obj.sequence,
      answers: [answer],
    }
    handleJacketInput(spec, "specifications", idx)
  }
  const onDropdownSelect = (e, obj, idx) => {
    const answer = { sequence: e.value, answer: e.label }
    const stateSpec = [...jacketSpecifications]
    const spec = {
      formId: obj.formId,
      sequence: obj.sequence,
      answers: [answer],
    }

    stateSpec[i] = {
      label: spec.answers[0].label,
      value: spec.answers[0].sequence,
    }
    setJacketSpecificatons(stateSpec)
    handleJacketInput(spec, "specifications", i)
  }
  return (
    <Card>
      <CardBody>
        <Row>
          <Col sm={6}>
            <Table bordered>
              <tbody>
                <tr style={{ height: 54 }}>
                  <td style={{ width: 105 }}>⽣地商社</td>
                  <td style={{ padding: 5 }}>
                    <SelectBox
                      isAsync={true}
                      loadOptions={config.loadFabricTrading}
                      defaultValue={config.fabricTradingValue}
                      value={config.fabricTradingValue}
                      onChange={e =>
                        config.handleCommonInput(e, "fabricCompanyId")
                      }
                    />
                  </td>
                </tr>
                <tr style={{ height: 54 }}>
                  <td style={{ width: 105 }}>⽣地年度</td>
                  <td style={{ padding: 5 }}>
                    <SelectBox
                      options={config.yearOption}
                      defaultValue={config.yearValue}
                      value={config.yearValue}
                      onChange={e => config.handleCommonInput(e, "year")}
                      isDisabled={
                        !config.fabricTradingValue ||
                        config.fabricTradingValue?.value === ""
                      }
                    />
                  </td>
                </tr>
                <tr style={{ height: 54 }}>
                  <td style={{ width: 105 }}>混率</td>
                  <td style={{ padding: 5 }}>
                    <Input
                      type="text"
                      value={config.rank?.mixedRatio}
                      disabled
                      readOnly
                    />
                  </td>
                </tr>
                <tr style={{ height: 54 }}>
                  <td style={{ width: 105 }}>⽣地⼱</td>
                  <td style={{ padding: 5 }}>
                    <Input
                      type="text"
                      value={config.rank?.clothWidth}
                      readOnly
                      disabled
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
          <Col sm={6}>
            <Table bordered>
              <tbody>
                <tr style={{ height: 54 }}>
                  <td style={{ width: 105 }}>⽣地</td>
                  <td style={{ padding: 5 }}>
                    <SelectBox
                      isAsync
                      loadOptions={config.loadFabric}
                      defaultValue={config.fabricValue}
                      defaultOptions={config.fabricOption}
                      value={config.fabricValue}
                      onChange={e => config.handleCommonInput(e, "fabricId")}
                      isDisabled={
                        !config.fabricTradingValue ||
                        config.fabricTradingValue.value === ""
                      }
                      formatOptionLabel={item => <FabricOptions item={item} />}
                    />
                  </td>
                </tr>
                <tr style={{ height: 54 }}>
                  {/* season */}
                  <td style={{ width: 105 }}>⽣地シーズン</td>
                  <td style={{ padding: 5 }}>
                    <SelectBox
                      options={config.seasonOption}
                      defaultValue={config.seasonValue}
                      value={config.seasonValue}
                      onChange={e => config.handleCommonInput(e, "seasonId")}
                      isDisabled={
                        !config.yearValue?.value || !config.fabricValue?.value
                      }
                    />
                  </td>
                </tr>
                <tr style={{ height: 54 }}>
                  <td style={{ width: 105 }}>ランク</td>
                  <td style={{ padding: 5 }}>
                    <Input
                      type="text"
                      value={config.rank?.rank}
                      disabled
                      readOnly
                    />
                  </td>
                </tr>
                <tr style={{ height: 54 }}>
                  <td style={{ width: 105 }}>⽤尺</td>
                  <td style={{ padding: 5, position: "relative" }}>
                    <input
                      name="scale"
                      onChange={e => handleJacketInput(e, "scale")}
                      style={{ height: 33 }}
                      className="form-control scale-input"
                      type="number"
                      value={config?.payload?.jacket?.scale || ""}
                      defaultValue={config?.payload?.jacket?.scale || ""}
                    />
                    <p
                      style={{
                        position: "absolute",
                        right: 15,
                        top: 15,
                        opacity: 0.5,
                      }}
                    >
                      M
                    </p>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>

        <Row>
          {config?.orderSheets?.jacket?.specifications &&
            config.orderSheets.jacket.specifications
              // .filter(spec => spec.item)
              .map((spec, i) => (
                <Col sm={6} key={spec.formId}>
                  <Table bordered>
                    <tbody>
                      {spec.format === null ? (
                        <tr style={{ height: 54 }} key={i}>
                          <td></td>
                        </tr>
                      ) : (
                        <tr style={{ height: 54 }}>
                          <td style={{ width: 165 }}>{spec.item}</td>
                          <td style={{ padding: 5 }}>
                            {spec.format === "チェックボックス" ? ( // checkbox
                              <div className="d-flex justify-content-start gap-4">
                                {spec.labels.map(label => {
                                  return (
                                    <div key={label.label}>
                                      <Input
                                        name={`${spec.formId}${i}`}
                                        id={`${spec.formId}${label.sequence}`}
                                        className="me-2"
                                        type="checkbox"
                                        value={label.sequence}
                                        onChange={e =>
                                          onCheckboxChecked(e, spec, i)
                                        }
                                        data-answer={label.label}
                                        defaultChecked={false}
                                      />
                                      <Label
                                        className="mb-0"
                                        htmlFor={`${spec.formId}${label.sequence}`}
                                      >
                                        {label.label}
                                      </Label>
                                    </div>
                                  )
                                })}
                              </div>
                            ) : spec.format === "ラジオボタン" ? ( // Radio
                              <div className="d-flex justify-content-start gap-4">
                                {spec.labels.map(label => {
                                  return (
                                    <div key={label.label}>
                                      <Input
                                        name={`spec${spec.formId}`}
                                        id={`${spec.formId}${label.sequence}`}
                                        className="me-2"
                                        type="radio"
                                        value={label.sequence}
                                        onChange={e =>
                                          onRadioSelect(e, spec, i, label.label)
                                        }
                                        defaultChecked={false}
                                      />
                                      <Label
                                        htmlFor={`${spec.formId}${label.sequence}`}
                                        className="mb-0"
                                      >
                                        {label.label}
                                      </Label>
                                    </div>
                                  )
                                })}
                              </div>
                            ) : spec.format === "プルダウン" ? ( // select
                              <div style={{ width: "100%" }}>
                                <SelectBox
                                  options={spec.labels.map(l => ({
                                    label: l.label,
                                    value: l.sequence,
                                  }))}
                                  onChange={e => onDropdownSelect(e, spec, i)}
                                  value={jacketSpecifications[i]}
                                />
                              </div>
                            ) : (
                              // text input
                              <Input
                                className="me-2"
                                type="text"
                                onChange={e => onTextInputChange(e, spec, i)}
                                data-sequence={1}
                                defaultValue={
                                  config?.payload?.jacket?.specifications[i]
                                    ?.answers[0]?.answer
                                }
                              />
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
              ))}
        </Row>
      </CardBody>
    </Card>
  )
}
